<div [class.avatar--icon]="!url" class="avatar">
  <wp-icon *ngIf="!url" icon="user-circle" set="light"></wp-icon>
  <img *ngIf="!!url" [ngSrc]="url" alt="avatar" height="40" width="40" />
</div>
